"use client";

import { useRef, useState, useCallback } from "react";

interface AudioPreviewProps {
  previewUrl: string | null;
}

export default function AudioPreview({ previewUrl }: AudioPreviewProps) {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const togglePlay = useCallback(() => {
    if (!previewUrl || !audioRef.current) return;

    if (isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
    } else {
      // Pause all other audio elements
      document.querySelectorAll("audio").forEach((a) => {
        a.pause();
        a.currentTime = 0;
      });
      // Dispatch custom event to reset other players
      window.dispatchEvent(new CustomEvent("audio-stop"));

      audioRef.current.play().catch(() => {});
      setIsPlaying(true);
    }
  }, [isPlaying, previewUrl]);

  const handleEnded = useCallback(() => {
    setIsPlaying(false);
  }, []);

  // Listen for stop events from other players
  if (typeof window !== "undefined") {
    // This is handled in useEffect below
  }

  return (
    <>
      {previewUrl && (
        <audio
          ref={audioRef}
          src={previewUrl}
          onEnded={handleEnded}
          preload="none"
        />
      )}
      <button
        onClick={togglePlay}
        disabled={!previewUrl}
        className={`flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full transition-all duration-200 ${
          previewUrl
            ? isPlaying
              ? "bg-violet-500 text-white shadow-lg shadow-violet-500/30"
              : "bg-white/10 text-white/60 hover:bg-white/20 hover:text-white"
            : "cursor-not-allowed bg-white/5 text-white/20"
        }`}
        title={
          previewUrl
            ? isPlaying
              ? "Пауза"
              : "Прослушать"
            : "Превью недоступно"
        }
      >
        {isPlaying ? (
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="currentColor"
          >
            <rect x="2" y="1" width="3" height="10" rx="1" />
            <rect x="7" y="1" width="3" height="10" rx="1" />
          </svg>
        ) : (
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="currentColor"
          >
            <path d="M3 1.5v9l7.5-4.5L3 1.5z" />
          </svg>
        )}
      </button>
    </>
  );
}
